import { useTranslation } from 'react-i18next';
import { Form, Label } from '@anytag/shared-atoms';
import { AUDIENCE_RATIO_OPTIONS, AUDIENCE_GENDER_OPTIONS, AUDIENCE_AGE_GROUP_OPTIONS } from '@anytag/shared-constants';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { SelectorField } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys } from '../schemaTypes';

interface DemographicFieldProps {
  title?: string;
  className?: string;
}

export const DemographicField = ({ title, className }: DemographicFieldProps) => {
  const { t } = useTranslation();
  const genderOptions = useTranslateOptions(AUDIENCE_GENDER_OPTIONS);
  const ageOptions = [{ label: t('All'), value: '' }, ...AUDIENCE_AGE_GROUP_OPTIONS];

  return (
    <Form.Field className={className}>
      <Label title={title ?? t('Demographics')} />

      <Form.Fields className="gap-x-2">
        <Form.Field className="flex items-center">
          <Label title={t('Selector.Gender')} className="mr-1 flex-0" />
          <SelectorField<InfluencersFilterFormKeys> name="audienceGender" options={genderOptions} />
        </Form.Field>

        <Form.Field className="flex items-center">
          <Label title={t('Selector.Age')} className="mr-1 flex-0" />
          <SelectorField<InfluencersFilterFormKeys> name="audienceAge" options={ageOptions} clearable={false} />
        </Form.Field>

        <Form.Field className="flex items-center">
          <Label title={t('Selector.Ratio')} className="mr-1 flex-0" />
          <SelectorField<InfluencersFilterFormKeys> name="audienceRatio" options={AUDIENCE_RATIO_OPTIONS} />
        </Form.Field>
      </Form.Fields>
    </Form.Field>
  );
};
